export default {
    delete_keyfob_title: "Borrar la llave del conductor",
    delete_keyfob_success_message: "La llave del conductor ha sido borrado",
    delete_keyfob_label: "¿Estás seguro de que quieres borrar la llave del conductor?",
    delete_keyfob_warning: "Esta acción no se puede deshacer. Esto eliminará permanentemente los datos y sus asociaciones.",
}